<template>
  <div>
    <h1 class="center">{{$t('signup')}}</h1>
    <a-form :form="form" @submit="handleSubmit">
      <a-form-item
        :validate-status="error('firstName') ? 'error' : ''"
        :help="error('firstName') || ''"
      >
        <a-input
          v-decorator="[
            'firstName',
            {
              rules: [
                {
                  required: true,
                  message: 'Please input your First Name!'
                }
              ]
            }
          ]"
          placeholder="John"
        >
          <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
        </a-input>
      </a-form-item>
      <a-form-item
        :validate-status="error('lastName') ? 'error' : ''"
        :help="error('lastName') || ''"
      >
        <a-input
          v-decorator="[
            'lastName',
            {
              rules: [
                {
                  required: true,
                  message: 'Please input your Last Name'
                }
              ]
            }
          ]"
          placeholder="Doe"
        >
          <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
        </a-input>
      </a-form-item>
      <a-form-item :validate-status="error('email') ? 'error' : ''" :help="error('email') || ''">
        <a-input
          v-decorator="[
            'email',
            {
              rules: [
                {
                  type: 'email',
                  message: 'The input is not valid E-mail!'
                },
                {
                  required: true,
                  message: 'Please input your E-mail!'
                }
              ]
            }
          ]"
          placeholder="email"
        >
          <a-icon slot="prefix" type="mail" style="color:rgba(0,0,0,.25)" />
        </a-input>
      </a-form-item>
      <a-form-item
        :validate-status="error('password') ? 'error' : ''"
        :help="error('password') || ''"
      >
        <a-input-password
          placeholder="Password"
          v-decorator="[
            'password',
            {
              rules: [
                {
                  required: true,
                  message: 'Please input your password!'
                }
              ]
            }
          ]"
        >
          <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
        </a-input-password>
      </a-form-item>
      <a-form-item>
        <a-button type="link">
          <router-link to="/login">{{$t('login')}}</router-link>
        </a-button>
        <a-button
          type="primary"
          html-type="submit"
          :loading="processing"
          :disabled="hasErrors(form.getFieldsError())"
        >{{$t('signup')}}</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { hasErrors } from "../utils.js";
import fb from "../firebaseConfig.js";

export default {
  name: "signup",
  components: {},
  data() {
    return {
      processing: false,
      confirmDirty: false,
      hasErrors,
      form: this.$form.createForm(this, { name: "Signup Form" })
    };
  },
  mounted() {
    this.$nextTick(() => this.form.validateFields()); // To disabled submit button at the beginning.
  },
  methods: {
    ...mapActions({ signup: "auth/signup" }),
    error(name) {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched(name) && getFieldError(name);
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.processing = true;
          this.signup({
            email: values.email,
            password: values.password,
            firstName: values.firstName,
            lastName: values.lastName
          })
            .then(d => {
              this.processing = false;
              this.$router.push("/");
            })
            .catch(err => (this.processing = false));
        } else {
          this.form.validateFields();
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../styles/variables.less";
form {
  text-align: left;
  max-width: 640px;
  margin: 0 auto;
}
.extras {
  margin-top: 8px;
}
</style>
